import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { useEffect } from "react";
import { whatsapp_broadcasts_apis } from "ui/pages/whatsappBroadcast/whatsappBroadCast.api";
import { useWAIntegrationStore } from "../../Whatsapp/store/useWAIntegrationStore";

export const useWAIntegration = () => {
  const { data, isSuccess, isFetching, isRefetching } = useCustomQuery({
    url: whatsapp_broadcasts_apis.get_whatsapp_white_label_details,
    queryKey: [whatsapp_broadcasts_apis.get_whatsapp_white_label_details],
    cacheTime: 0,
  });
  const initWADetails = useWAIntegrationStore((state) => state.setDetails);

  useEffect(() => {
    const handleInitDetails = () => {
      if (data && isSuccess) {
        initWADetails(data);
      }
    };

    handleInitDetails();
  }, [data, isSuccess]);

  return {
    loading: isFetching && !isRefetching,
  };
};
